export const issuedCertificates = [
  {
    retailer: "Retailer A",
    brpId: "12409",
    territory: "Pune",
    certificateNo: "010",
    issueDate: "25/05/2025",
    status: "Active",
  },
  {
    retailer: "Retailer B",
    brpId: "12408",
    territory: "Sangli",
    certificateNo: "009",
    issueDate: "21/05/2025",
    status: "Expired",
  },
  {
    retailer: "Retailer C",
    brpId: "12407",
    territory: "Kolhapur",
    certificateNo: "008",
    issueDate: "18/05/2025",
    status: "Cancelled",
  },
  {
    retailer: "Retailer D",
    brpId: "12407",
    territory: "Kolhapur",
    certificateNo: "",
    issueDate: "",
    status: "Rejected",
  },
];

export const pendingRequests = [
  {
    retailer: "Retailer A",
    brpId: "12409",
    deadline: "overdue by 4 days",
    certificateNo: "010",
    datesubmitted: "25/05/2025",
    status: "Pending Approval",
  },
  {
    retailer: "Retailer D",
    brpId: "12407",
     deadline: "overdue by 4 days",
    certificateNo: "",
    datesubmitted: "25/06/2023",
    status: "Pending Delivery",
  },
  {
    retailer: "Retailer B",
    brpId: "12408",
    deadline: "overdue by 4 days",
    certificateNo: "009",
    datesubmitted: "21/05/2025",
    status: "Pending Approval",
  }
];


export const ROLES = {
  'ISSUER': 'ISSUER',
  'APPROVER': 'APPROVER',
  'LICENSE_MANAGER': 'LICENSE_MANAGER'
}


export const VIEWER_ROLES = {
  'CCMM':'CCMM',
  'UL':'UL',
  'CL': 'CL',
  'VIEWER': 'VIEWER'
}

export const FilterByStatus = [
  'Pending Review', 'Pending Delivery', 'Completed'
]

export const RequestState = {
  'APPROVED': 'Approved',
  'PENDING': 'Pending Approval',
  'ACTIVE': 'Active',
  'PENDING_DELIVERY': "Pending Delivery",
}


 export const BUFFER_DAYS = 7; 